import * as fb from "firebase";
import GlobalContext from "./GlobalContext";

const firebaseConfig = {
  apiKey: "AIzaSyDF9psMQY6kVeOpSSSr3-NRge4Erep6Jk0",
  authDomain: "bss-test-d2bce.firebaseapp.com",
  databaseURL: "https://bss-test-d2bce.firebaseio.com",
  projectId: "bss-test-d2bce",
  storageBucket: "bss-test-d2bce.appspot.com",
  messagingSenderId: "163362620232",
  appId: "1:163362620232:web:2993d9a4a43fa62384e97d",
  measurementId: "G-E00GMPPPEX"
};

if (!fb.apps.length) {
  fb.initializeApp(firebaseConfig);
}

class FirebaseDB {
  constructor(src) {
    console.log("firebase src=" + src);
  }

  getDate() {
    var today = new Date();
    var date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    var time =
      today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var dateTime = date + " " + time;

    return dateTime;
  }

  doMetrics(search) {
    let lcookie = GlobalContext().cookie;
    if (!lcookie) {
      console.log("err no cookie!!");
      return;
    }

    let uScreen = `w:${window.screen.width} x h:${window.screen.height}`;

    var data = {
      source: window.location.href,
      user: lcookie,
      agent: navigator.userAgent,
      screen: uScreen
    };

    data.time = this.getDate();

    if (search)
      data.query = search;

    const newRef = fb
      .database()
      .ref("metrics/" + data.user)
      .push();

    const regex = /^-M[_a-zA-Z0-9\-]{17,20}$/;
    const result = regex.test(newRef.key);

    if (result) {
      console.log("do metrics:" + data.source);
      newRef.set(data, function () { });
    }

  }

  upload(dBkey, item, onComplete) {
    item.time = this.getDate();

    let lcookie = GlobalContext().cookie;
    if (lcookie) {
      item.user = lcookie;
    }

    const newRef = fb.database().ref(dBkey).push();

    const regex = /^-M[_a-zA-Z0-9\-]{17,20}$/;
    const result = regex.test(newRef.key);

    if (result) {
      console.log("result true");
      newRef.set(item, function (error) {
        if (onComplete) {
          if (error) onComplete(0);
          else onComplete(1);
        }
      });
    }
  }

  analyticsLogEvent(event) {
    fb.analytics().logEvent(event);
  }
}

export default FirebaseDB;
